import React, { useRef } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import useGetSectionFilters from 'components/Dashboard/Filters/useGetSectionFilters';
import { decodeUrlQueryValue } from 'components/Dashboard/utilities/getUrlParam';
import useIsMobile from 'components/Dashboard/utilities/useIsMobile';
import { store } from 'components/Store';
import { useContext } from 'react';

function SubnavSearchBar(props) {
  const globalState = useContext(store);
  const { dispatch } = globalState;

  const { className = '', placeholder } = props ?? {};

  const [searchValue, setSearchValue] = useState('');

  const location = useLocation();
  const navigate = useNavigate();
  const query = new URLSearchParams(location.search);

  const { getSectionFilters } = useGetSectionFilters('InfluenceContacts');
  const sectionFilters = getSectionFilters();
  const { hash } = sectionFilters;

  const inputSearch = useRef(null);
  const isSmallMobile = useIsMobile(480);

  useEffect(() => {
    const searchQuery = query.get('search') ? decodeUrlQueryValue(query.get('search')) : '';
    setSearchValue(searchQuery);
  }, [location.search]);

  const setStringValue = ({ value, type }) => {
    dispatch({
      type: 'MODIFY_SECTION',
      parameter: `search${type}String`,
      value: value,
    });
  };

  const searchResults = (value) => {
    if (location.pathname.includes('contacts')) {
      setStringValue({ value, type: 'Contacts' });
    } else if (location.pathname.includes('emails')) {
      setStringValue({ value, type: 'Emails' });
    }
    if (value.trim() === '') {
      query.delete('search');
    } else {
      query.set('search', encodeURIComponent(value));
    }
    const pathname = location.pathname.includes('contacts/update') ? '/people/directory' : location.pathname;
    if (pathname === '/people/directory') {
      query.delete('sort');
    }
    let urlToHistory = `${pathname}?${query.toString()}${
      hash !== '' && location.pathname.includes('/directory') ? `#${hash}` : ''
    }`;
    navigate(urlToHistory, { replace: true });
  };

  return (
    <div className={`sub-nav-searchbar influence-search-bar ${className}`}>
      <div className='position-relative'>
        <div
          className={
            'simple-searchbar flex-centered simple-searchbar-open simple-searchbar-open-influence simple-searchbar-influence'
          }
        >
          <span className={`icon-search title-h5-m`} style={{ margin: '2px 11px 0 -1px', color: '#9c9c9c' }} />
          <div className='flex-grow-1'>
            <input
              className={`search-main-input w-100`}
              data-hj-allow
              type='text'
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value);
              }}
              style={{ height: '28px' }}
              onKeyDown={(e) => {
                if (e.keyCode === 13) {
                  let value = e.target.value;
                  inputSearch.current.blur();
                  searchResults(value);
                } else if (e.metaKey && e.key === 'a') {
                  e.preventDefault();
                  inputSearch.current.select();
                } else if (e.keyCode === 9) {
                  e.preventDefault();
                }
              }}
              ref={inputSearch}
              placeholder={
                placeholder
                  ? placeholder
                  : isSmallMobile
                    ? 'Search'
                    : location.pathname.includes('/directory')
                      ? 'Search by name, role, description or tag'
                      : location.pathname.includes('/emails')
                        ? 'Search emails'
                        : location.pathname.includes('/my-groups')
                          ? 'Search groups'
                          : 'Search my lobbying material'
              }
            />
          </div>
          {(searchValue !== '' || query.has('search')) && (
            <div className='close-icon-container'>
              <button
                className='general-button close-icon'
                data-tooltip-content='Clear search'
                data-tooltip-id='general-tooltip'
                data-tooltip-place='right'
                onClick={(e) => {
                  e.stopPropagation();
                  if (location.pathname.includes('contacts')) {
                    setStringValue({ value: '', type: 'Contacts' });
                  } else if (location.pathname.includes('emails')) {
                    setStringValue({ value: '', type: 'Emails' });
                  }
                  query.delete('search');
                  if (location.pathname.includes('people/directory') && !query.has('sort')) {
                    query.set('sort', 'lastName_asc');
                  }
                  let urlToHistory = `${location.pathname}?${query.toString()}${
                    hash !== '' && location.pathname.includes('/directory') ? `#${hash}` : ''
                  }`;
                  navigate(urlToHistory, { replace: true });
                  setSearchValue('');
                  inputSearch?.current?.focus();
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SubnavSearchBar;
